import Joi from "joi";
import errorsResolver from "../schemeUtils";

const FIELD_LENGTH = 100;

const branchScheme = (isMainEnable) => {
  const baseSchema = {
    branchName: Joi.string()
      .max(FIELD_LENGTH)
      .required()
      .pattern(new RegExp("^[a-zA-Zа-яА-ЯёЁ0-9.,№\\- ]*$"))
      .error(
        errorsResolver({
          max: `Название должно быть до ${FIELD_LENGTH} символов`,
          required: `Название обязательное поле`,
          pattern: `Название содержит некорректные символы`,
        })
      ),
    directorIds: Joi.array()
      .items(
        Joi.object({
          label: Joi.string()
            .max(FIELD_LENGTH)
            .required("")
            .pattern(new RegExp("^[a-zA-Zа-яА-ЯёЁ0-9\\- ]*$"))
            .error(
              errorsResolver({
                max: `Директор должно быть до ${FIELD_LENGTH} символов`,
                required: `Директор обязательное поле`,
                pattern: `Директор содержит некорректные символы`,
              })
            ),
          value: Joi.number().error(
            errorsResolver({
              number: `Должно быть число`,
            })
          ),
        })
      )
      .invalid(null)
      .required()
      .min(1)
      .max(2)
      .error(
        errorsResolver({
          invalid: `Директор обязательное поле`,
          required: `Директор обязательное поле`,
          min: `Директор обязательное поле`,
          arrayMax: "Не более двух директоров",
        })
      ),
    listCashboxes: Joi.array()
      .items(
        Joi.object({
          label: Joi.string()
            .max(FIELD_LENGTH)
            .required("")
            .pattern(new RegExp("^[a-zA-Zа-яА-ЯёЁ0-9\\-№ ]*$"))
            .error(
              errorsResolver({
                max: `Подразделения должно быть до ${FIELD_LENGTH} символов`,
                required: `Подразделения обязательное поле`,
                pattern: `Подразделения содержит некорректные символы`,
              })
            ),
          value: Joi.number().error(
            errorsResolver({
              number: `Должно быть число`,
            })
          ),
        })
      )
      .invalid(null)
      .required()
      .min(1)
      .error(
        errorsResolver({
          invalid: `Подразделения обязательное поле`,
          required: `Подразделения обязательное поле`,
          min: `Подразделения обязательное поле`,
        })
      ),
  };

  if (!isMainEnable) {
    baseSchema.sendUserAllowed = Joi.object({
      label: Joi.string()
        .max(FIELD_LENGTH)
        .required()
        .pattern(new RegExp("^[a-zA-Zа-яА-ЯёЁ0-9\\- ]*$"))
        .error(
          errorsResolver({
            max: `Отпуск ТН разрешил должно быть до ${FIELD_LENGTH} символов`,
            required: `Отпуск ТН разрешил обязательное поле`,
            pattern: `Отпуск ТН разрешил содержит некорректные символы`,
          })
        ),
      value: Joi.number().error(
        errorsResolver({
          number: `Должно быть число`,
        })
      ),
    })
      .required()
      .error(
        errorsResolver({
          invalid: `Отпуск ТН разрешил обязательное поле`,
          required: `Отпуск ТН разрешил обязательное поле`,
          objectBase: 'Отпуск ТН разрешил обязательное поле'
        })
      );
  } else {
    baseSchema.sendUserAllowed = Joi.any().optional();
  }

  return Joi.object(baseSchema);
};

export default branchScheme;
